import React from "react";
import ReactDOM from "react-dom";
import FavouriteBadge from "../elements/components/FavouriteBadge";

const rootElement = document.getElementById("favourite-badge");

if (rootElement) {
    const dynamic = rootElement.getAttribute('data-dynamic');
    ReactDOM.render(<FavouriteBadge dynamic={dynamic} />, rootElement);
}
